/* eslint-disable import/prefer-default-export */
import AlignmentChart from './components/AlignmentChart.react';
import Circos from './components/Circos.react';
import FornaContainer from './components/FornaContainer.react';
import Ideogram from './components/Ideogram.react';
import Igv from './components/Igv.react';
import Pileup from './components/Pileup.react';
import Molecule2dViewer from './components/Molecule2dViewer.react';
import Molecule3dViewer from './components/Molecule3dViewer';
import NeedlePlot from './components/NeedlePlot.react';
import NglMoleculeViewer from './components/NglMoleculeViewer.react';
import OncoPrint from './components/OncoPrint.react';
import SequenceViewer from './components/SequenceViewer.react';
import Speck from './components/Speck.react';

export {
    AlignmentChart,
    Circos,
    FornaContainer,
    Ideogram,
    Igv,
    Pileup,
    Molecule2dViewer,
    Molecule3dViewer,
    NeedlePlot,
    NglMoleculeViewer,
    OncoPrint,
    SequenceViewer,
    Speck,
};
